<template>
	<PopupRouterViewDetail label="Approval Configuration Detail" @hideMethod="onHidden" :isShowCopyData="false">
<!-- APP_DETAIL_HEADER -->
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-name" label-cols-lg="12" label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isUpdatable="true" @change="updateData" :returnValue="updateDataReturnValue" />
						<app-input-combobox-autocomplete :options="approvalTypes" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Approval Type" id="input-approval-type" name="approval-type" size="sm" :model.sync="model.approvalTypeId"  :selected="model.approvalType != null ? model.approvalType.name : ''" @input="getApprovalTypes" :loading="isApprovalComboLoading" :isUpdatable="true" @change="updateData" :returnValue="updateDataReturnValue"/>
						<app-input-textarea id="fieldset-description" label-cols-lg="12" label="Description" label-for="input-description" size="sm" :model.sync="model.description" :isUpdatable="true" @change="updateData" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="appliedTos" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Applied To" id="input-applied-to" name="applied-to" size="sm" :model.sync="model.appliedToId"  :selected="model.appliedTo != null ? model.appliedTo.name : ''" @input="getAppliedTos" :loading="isAppliedToComboLoading" :isUpdatable="true" @change="updateData" />
						<app-input-combobox-autocomplete v-if="model.appliedToId == 'USER'" :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-lg="12" label="User Name" id="input-user-info" name="user-info" size="sm" :model.sync="model.userInfoUserName"  :selected="model.userInfo != null ? model.userInfo.FirstName : ''" @input="getUserInfos" :loading="isUserInfoComboLoading" :isUpdatable="true" @change="updateData" />
						<app-input-combobox-autocomplete v-if="model.appliedToId == 'APPROVAL GROUP'" :options="approvalGroups" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Approval Group" id="input-approval-group" name="approval-group" size="sm" :model.sync="model.approvalGroupId"  :selected="model.approvalGroup != null ? model.approvalGroup.name : ''" @input="getApprovalGroups" :loading="isApprovalGroupComboLoading" :isUpdatable="true" @change="updateData" />
						<app-input-textbox v-if="model.appliedToId == 'USER LEVEL'" id="fieldset-user-level" label-cols-lg="12" type="number" label="User Level" label-for="input-user-level" size="sm" :model.sync="model.userLevel" :isUpdatable="true" @change="updateData" />
						<app-input-checkbox id="fieldset-is-partial-approval" label-cols-lg="12" label="Partial Approval" label-for="input-is-partial-approval" size="sm" :model.sync="model.usePartialApproval" :isUpdatable="true" checkedValue="Yes" uncheckedValue="No" @change="updateData" />
						<app-input-checkbox id="fieldset-is-sent-email" label-cols-lg="12" label="Is Send Email" label-for="input-is-sent-email" size="sm" :model.sync="model.isSentEmail" :isUpdatable="true" checkedValue="Yes" uncheckedValue="No" @change="updateData" />
						<app-input-checkbox id="fieldset-has-approval" label-cols-lg="12" label="Has Approval" label-for="input-has-approval" size="sm" :model.sync="model.hasApproval" :isUpdatable="true" checkedValue="Yes" uncheckedValue="No" @change="updateData" />
				</b-col>
			</b-row>
		</b-card>
<!-- END_APP_DETAIL_HEADER -->
<!--APP_DETAIL_TABLE-->
	<div class="table-detail mt-4">
		<b-row class="mb-2">
			<b-col cols="9"><h5 class="card-title font-weight-bolder text-dark">Approval Configuration Detail</h5></b-col>
			<b-col>
				<span class="float-right">
					<b-form-select v-model="approvalConfigurationDetailPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
		<b-row>
		<b-col>
			<div class="table-corner">
			<b-table class="table-action" 
				:bordered="true" 
				stacked="md" 
				head-variant="head-light" 
				:no-local-sorting="true" 
				:items="approvalConfigurationDetails" 
				:fields="fieldsApprovalConfigurationDetail" 
				:busy="isDataLoading" 
				:sort-by.sync="sortByApprovalConfigurationDetail" 
				:sort-desc.sync="sortDescApprovalConfigurationDetail" small responsive>
			<!--APP_TABLE_FILTER-->
			<template v-slot:head(frontActions)>
				<div class="row justify-content-center">
					<b-button @click="isShowApprovalConfigurationDetailFilter = !isShowApprovalConfigurationDetailFilter" class="" size="sm"><b-icon-funnel-fill /></b-button>
				</div>
			</template>
			<template #top-row v-if="isShowApprovalConfigurationDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Approver Type">
					<v-select append-to-body label="name" :options="approverTypes" :value="filterApprovalConfigurationDetail.approverTypeId" :reduce="item => item.id" v-model="filterApprovalConfigurationDetail.approverTypeId" @search="getApproverTypes" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Approval Structure">
					<v-select append-to-body label="name" :options="approvalStructures" :value="filterApprovalConfigurationDetail.approvalStructureId" :reduce="item => item.id" v-model="filterApprovalConfigurationDetail.approvalStructureId" @search="getApprovalStructures" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Approver Level">
					<b-form-input id="input-approver-level-table" v-model="filterApprovalConfigurationDetail.approverLevel" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Approver User Name">
					<v-select append-to-body label="firstName" :options="userInfos" :value="filterApprovalConfigurationDetail.approverUserNameUserName" :reduce="item => item.userName" v-model="filterApprovalConfigurationDetail.approverUserNameUserName" @search="getUserInfos" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Stored Procedure Name">
					<b-form-input id="input-stored-procedure-name-table" v-model="filterApprovalConfigurationDetail.storedProcedureName" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Approval Type">
					<b-form-input id="input-approval-type-table" v-model="filterApprovalConfigurationDetail.approvalType" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Configuration Content">
					<b-form-input id="input-configuration-content-table" v-model="filterApprovalConfigurationDetail.configurationContent" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Is Send Notification">
					<b-form-checkbox id="input-is-send-notification-table" class="float-right" v-model="filterApprovalConfigurationDetail.isSendNotification"></b-form-checkbox>
				</b-th>
			</template>
			<!--END_APP_TABLE_FILTER-->
			<!--APP_TABLE_DATA-->
			<template v-slot:cell(frontActions)="row">
				<b-button size="sm"
				@click="editDataApprovalConfigurationDetail(row)" class="mr-2 btn-xs btn-default-white border-0">
				<b-icon-pencil></b-icon-pencil>
				</b-button>
				<b-overlay
				rounded
				opacity="0.6"
				spinner-small
				spinner-variant="primary"
				class="d-inline-block"
				>
				<click-confirm>
					<b-button size="sm"
						@click="deleteDataApprovalConfigurationDetail(row)" class="mr-2 btn-xs btn-default-white border-0">
						<b-icon-trash></b-icon-trash>
					</b-button>
				</click-confirm>
			</b-overlay>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( approvalConfigurationDetailPageSize * (currentApprovalConfigurationDetailPage - 1))) }}
			</template>
			<template v-slot:cell(approvalConfiguration)="row">
				<span class="label-detail">
					<span class="col">
						{{ row.item.approvalConfiguration != null ? row.item.approvalConfiguration.name : "" }}
					</span>
				</span>
			</template>
			<template v-slot:cell(approverType)="row">
				<app-input-combobox-autocomplete :options="approverTypes" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Approver Type" :id="'input-approver-type-' + row.index" :name="'applied-to-' + row.index" size="sm" :model.sync="row.item.approverTypeId"  :selected="row.item.approverType != null ? row.item.approverType.name : ''" @input="getApproverTypes" :loading="isApproverTypeToComboLoading" :isUpdatable="true" :nolabel="true" @change="updateDataDetail(row.item)"  :returnValue="updateDataReturnValue"/>
			</template>
			<template v-slot:cell(approvalStructure)="row">
				<app-input-combobox-autocomplete :options="approvalStructures" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Approver Structure" :id="'input-approval-structure-' + row.index" :name="'approval-structure-' + row.index" size="sm" :model.sync="row.item.approvalStructureId"  :selected="row.item.approvalStructure != null ? row.item.approvalStructure.name : ''" @input="getApprovalStructures" :loading="isApprovalStructureComboLoading" :isUpdatable="true" :nolabel="true" @change="updateDataDetail(row.item)"/>
			</template>
			<template v-slot:cell(approverUserName)="row">
				{{ row.item.approverUserName != null ? row.item.approverUserName.firstName : "" }}
			</template>
			<template v-slot:cell(approverLevel)="row">
				<app-input-textbox v-if="row.item.approverTypeId == 'SUPERIOR'" :id="'input-approver-level-' + row.index" label-cols-lg="12" type="number" label="User Level" label-for="input-approver-level" size="sm" :model.sync="row.item.approverLevel" :isUpdatable="true" @change="updateDataDetail(row.item)"  :nolabel="true" />
			</template>
			<template v-slot:cell(configurationContent)="row">
				<!-- {{ row.item.configurationContent != null ? row.item.configurationContent : "" }} -->
				<!-- <a href="approvalconfiguration/ConfigurationContent/'" + row.item.id>{{ row.item.configurationContent != null ? row.item.configurationContent : "" }}</a> -->
				<a href="javascript:void" @click="showConfigurationContent(row.item.configurationContent)">{{ row.item.configurationContent != null ? row.item.configurationContent : "" }}</a>
				<!-- <a href="/approvalconfiguration/detail/'" + row.item.id>{{ row.item.configurationContent != null ? row.item.configurationContent : "" }}</a>
				<a href="/approvalconfiguration/detail/">{{ row.item.configurationContent != null ? row.item.configurationContent : "" }}</a> -->
			</template>
			<!--END_APP_TABLE_DATA-->
			</b-table>
			</div>
		</b-col>
		<b-col cols="6">
			<b-button class="btn-default-white" @click="addDataApprovalConfigurationDetail" size="sm">Add</b-button>
		</b-col>
		<b-col cols="6">
			<!--APP_TABLE_PAGINATION-->
			<b-pagination
			class="float-right btn-paging"
			v-model="currentApprovalConfigurationDetailPage"
			:total-rows="totalApprovalConfigurationDetailRow"
			:per-page="approvalConfigurationDetailPageSize"
			aria-controls="my-table"
			></b-pagination>
			<!--END_APP_TABLE_PAGINATION-->
		</b-col>
		</b-row>
	</div>
<!--END_APP_DETAIL_TABLE-->
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<!-- <ApprovalConfigurationContent :openPopup="isShowConfigurationContent" :modelId="modelId" @resetModalMethod="resetModal"/> -->
		<ApprovalConfigurationContent :openPopup="isShowConfigurationContent" :configurationContent="configurationContent" @resetMethod="resetModal"/>
		<ApprovalConfigurationDetailInput 
			:openPopup="isShowPopupApprovalConfigurationDetail"
			:modelId="approvalConfigurationDetailId"
			@resetMethod="resetModal"
			@addButtonMethod="addRowDataApprovalConfigurationDetail"/>
	</PopupRouterViewDetail>
</template>
<script>
/*APP_DETAIL_IMPORT*/
import ApprovalConfiguration from '@/models/ApprovalConfiguration/ApprovalConfiguration';
import ApprovalConfigurationList from '@/models/ApprovalConfiguration/ApprovalConfigurationList';
import ApprovalConfigurationFilter from '@/filters/ApprovalConfiguration/ApprovalConfigurationFilter';

import ApprovalConfigurationDetail from '@/models/ApprovalConfiguration/ApprovalConfigurationDetail';
import ApprovalConfigurationDetailFilter from '@/filters/ApprovalConfiguration/ApprovalConfigurationDetailFilter';
import ApproverType from '@/models/ApproverType/ApproverType';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
import AppliedTo from '@/models/AppliedTo/AppliedTo';
import AppliedToFilter from '@/filters/AppliedTo/AppliedToFilter';
import ApprovalGroup from '@/models/ApprovalGroup/ApprovalGroup';
import ApprovalGroupFilter from '@/filters/ApprovalGroup/ApprovalGroupFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import ApprovalType from '@/models/ApprovalType/ApprovalType';
import ApprovalTypeFilter from '@/filters/ApprovalType/ApprovalTypeFilter';
import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import ApprovalConfigurationContent from '@/views/ApprovalConfiguration/ApprovalConfigurationContent';
import PopupRouterView from '@/components/PopupRouterView';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputTimepicker from '@/components/AppInputTimepicker';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import AppInputFileupload from '@/components/AppInputFileupload';
import ApprovalConfigurationDetailInput from '@/views/ApprovalConfiguration/ApprovalConfigurationDetailInput';

/*END_APP_DETAIL_IMPORT*/
export default {
	components : {
	/*APP_DETAIL_PROP_DEFINITION*/
	PopupRouterViewDetail,AppInputDatetimepicker,AppInputDatetimepickerRange,ApprovalConfigurationContent,PopupRouterView, AppInputTextbox, AppInputComboboxAutocomplete, AppInputTextarea,AppInputDatepicker,AppInputCheckbox,AppInputFileupload,AppInputTimepicker,ApprovalConfigurationDetailInput
	/*APP_DETAIL_COMPONENTS_DEFINITION*/
},
	data() {
		return {
			fileupload: null,
			model: {},
			datas: Array(),
			fieldsApprovalConfigurationDetail: [
				{"frontActions": { "class" : "th-actions", "label" : "" }},
				{"no" : {  "class" : "th-number" }},
				{"approverType": {},  "class" : "th-approver-type", "label" : "Approver Type", key: 'approverType', sortable: true}, 
				{"approvalStructure": {},  "class" : "th-approval-structure", "label" : "Approval Structure", key: 'approvalStructure', sortable: true}, 
				{"approverLevel": {},  "class" : "th-approver-level", "label" : "Approver Level", key: 'approverLevel', sortable: true}, 
				{"approverUserName": {},  "class" : "th-approver-user-name", "label" : "Approver User Name", key: 'approverUserName', sortable: true}, 
				{"storedProcedureName": {},  "class" : "th-stored-procedure-name", "label" : "Stored Procedure Name", key: 'storedProcedureName', sortable: true}, 
				{"approvalType": {},  "class" : "th-approval-type", "label" : "Approval Type", key: 'approvalType', sortable: true}, 
				{"configurationContent": {},  "class" : "th-configuration-content", "label" : "Configuration Content", key: 'configurationContent', sortable: true}, 
				{"isSendNotification": {},  "class" : "th-is-send-notification", "label" : "Is Send Notification", key: 'isSendNotification', sortable: true}, 
				// {"actions": { "class" : "th-actions", "label" : "" }}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			model: {},
			/*APP_DETAIL_PAGINATION*/
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			/*END_APP_DETAIL_PAGINATION*/
			/*APP_DETAIL_FILTER*/
			filterApprovalConfiguration : null,
			/*END_APP_DETAIL_FILTER*/
			/*APP_DETAIL_PAGING_DEFINITION*/
			currentApprovalConfigurationPage : 1,
			approvalConfigurationPageSize: 10,
			/*END_APP_DETAIL_PAGING_DEFINITION*/
			/*APP_DETAIL_SORT_DEFINITION*/
			sortByApprovalConfiguration: '',
			sortDescApprovalConfiguration: '',
			/*END_APP_DETAIL_SORT_DEFINITION*/
			/*APP_DETAIL_VARIABLE_DEFINITION*/
			filterApprovalConfigurationDetail : null,
			currentApprovalConfigurationDetailPage : 1,
			approvalConfigurationDetailPageSize: 10,
			sortByApprovalConfigurationDetail: '',
			sortDescApprovalConfigurationDetail: '',
			sortingByApprovalConfigurationDetail: [],
			approvalConfigurationDetails : [],
			approvalConfigurationDetailId : '',
			totalApprovalConfigurationDetailRow : 0,
			isShowApprovalConfigurationDetailFilter: false,
			/*END_APP_DETAIL_VARIABLE_DEFINITION*/
			/*APP_DETAIL_OBJ_VARIABLE*/
			approverTypes: [],
			approvalStructures: [],
			userInfos: [],
			approvalTypes: [],
			appliedTos: [],
			approvalGroups: [],
			isShowConfigurationContent : false,
			configurationContent : '',
			mainRecordId: '',
			/*END_APP_DETAIL_OBJ_VARIABLE*/
			isApprovalComboLoading: false,
			isAppliedToComboLoading: false,
			isUserInfoComboLoading: false,
			isApprovalGroupComboLoading: false,
			isApproverTypeToComboLoading: false,
			isApprovalStructureComboLoading: false,
			createdDate: '2023-07-23',
			createdDateTime: '2023-07-23 10:23',
			createdTime: '2023-07-23 13:01',
			approvalConfigurationDetailId : '',
			isShowPopupApprovalConfigurationDetail : false,
			updateDataReturnValue: false,
		}
	},
	methods : {
		showConfigurationContent(data) {
			this.configurationContent = data;
			console.log(data); 
			this.isShowConfigurationContent = true;
			// this.modelId = id;
			// this.model.configurationContent = data;
			// console.log(data);
			console.log(id);
			console.log('TEST');
			// console.log(this.model.id);
			// this.model.id = id;
		},
		resetModal(){
			this.isShowPopupApprovalConfigurationDetail = false;
			this.isShowConfigurationContent = false;
			// this.getApprovalConfiguration(id);
			this.getApproverTypes();
			this.getApprovalStructures();
			this.getUserInfos();
			this.getApprovalTypes();
			this.getAppliedTos();
			this.getApprovalGroups();
		},
		/*APP_DETAIL_GETApprovalConfiguration*/
		getApprovalConfiguration : async function(id) {
			this.isBusy = true;
			ApprovalConfiguration.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		/*END_APP_DETAIL_GETApprovalConfiguration*/
		/*APP_DETAIL_GETApprovalConfigurationDetail*/
		getApprovalConfigurationDetails : async function() {
			let filter = {};
			Object.assign(filter, this.filterApprovalConfigurationDetail);
			if (this.modelId == null) return;
			filter.approvalConfigurationId = this.modelId;
			this.sortingByApprovalConfigurationDetail = Array();
			if (this.sortByApprovalConfigurationDetail != null && this.sortByApprovalConfigurationDetail!="") {
				this.sortingByApprovalConfigurationDetail[this.sortByApprovalConfigurationDetail] = this.sortDescApprovalConfigurationDetail;
			}else{
					this.sortingByApprovalConfigurationDetail["id"] = "1";
			}
			let currentPage = (this.currentApprovalConfigurationDetailPage - 1);
			ApprovalConfigurationDetail.getList(this, filter, this.sortingByApprovalConfigurationDetail, currentPage , this.approvalConfigurationDetailPageSize).then(result => {
				this.approvalConfigurationDetails = result.data;
				this.totalApprovalConfigurationDetailRow = result.dataCount;
			}).catch(error => {});
		},
		/*END_APP_DETAIL_GETApprovalConfigurationDetail*/
		/*APP_DETAIL_GETAPPROVERTYPE*/
		getApproverTypes : async function(input) {
			let filter = new ApproverTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isApproverTypeToComboLoading = true;
			ApproverType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approverTypes = result.data
				}
				this.isApproverTypeToComboLoading = false;
			})
			.catch(error => {this.isApproverTypeToComboLoading = false;});
		},
		/*END_APP_DETAIL_GETAPPROVERTYPE*/
		/*APP_DETAIL_GETAPPROVALSTRUCTURE*/
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			if(this.filterApprovalConfigurationDetail.approvalStructureId != undefined && input == '')
			{
				filter.id = this.filterApprovalConfigurationDetail.approvalStructureId;
			}
			this.isApprovalStructureComboLoading = true;
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
				this.isApprovalStructureComboLoading = false;
			})
			.catch(error => {this.isApprovalStructureComboLoading = false;});
		},
		/*END_APP_DETAIL_GETAPPROVALSTRUCTURE*/
		/*APP_DETAIL_GETUSERINFO*/
		getApprovalGroups : async function(input) {
			let filter = new ApprovalGroupFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isApprovalGroupComboLoading = true;
			ApprovalGroup.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalGroups = result.data
				}
				this.isApprovalGroupComboLoading = false;
			})
			.catch(error => {this.isApprovalGroupComboLoading = false;});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			
			if(this.filterApprovalConfigurationDetail.approverUserNameUserName != undefined && input == '')
			{
				filter.userName = this.filterApprovalConfigurationDetail.approverUserNameUserName;
			}
			this.isUserInfoComboLoading = true;
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
				this.isUserInfoComboLoading = false;
			})
			.catch(error => {this.isUserInfoComboLoading = false;});
		},
		getApprovalTypes : async function(input) {
			let filter = new ApprovalTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isApprovalComboLoading = true;
			ApprovalType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalTypes = result.data
				}
				this.isApprovalComboLoading = false;
			})
			.catch(error => {this.isApprovalComboLoading = false;});
		},
		getAppliedTos : async function(input) {
			let filter = new AppliedToFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isAppliedToComboLoading = true;
			AppliedTo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.appliedTos = result.data
				}
				this.isAppliedToComboLoading = false;
			})
			.catch(error => {this.isAppliedToComboLoading = false;});
		},
		/*END_APP_DETAIL_GETUSERINFO*/
		/*APP_DETAIL_COPYDATA*/
		copyDataAction(modelEvent) {
			this.$router.push({ name: 'approvalconfigurationcopydata', params: { id: this.modelId, copydata : 1 } })
		},
		/*END_APP_DETAIL_COPYDATA*/
		/*APP_DETAIL_DISPLAYFILTER*/
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowApprovalConfigurationDetailFilter = true;
			}
		},
		/*END_APP_DETAIL_DISPLAYFILTER*/
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			
			this.isBusy = true;
			let id = this.modelId;
			let model = this.model;

			if (id != '' && id != null && id != undefined) {
				ApprovalConfiguration.commitData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$router.push({ name: 'approvalconfigurationindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			} else {
				ApprovalConfiguration.insertData(this, model).then(result => {
					this.$router.push({ name: 'approvalconfigurationindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		updateData(returnValue) {
			//this.isBusy = true;
			let id = this.modelId;
			let model = this.model;

			this.updateDataReturnValue = returnValue;
			if (id != '' && id != null && id != undefined) {
				ApprovalConfiguration.updateDataDetail(this, model, id).then(result => {
					//this.$router.push({ name: 'approvalconfigurationindex' });
					this.isBusy = false;
					this.updateDataReturnValue = true;
				}).catch(error => { 
					this.isBusy = false;
					this.updateDataReturnValue = false;
				 });
			}
		},
		updateDataDetail(model) {
			console.log(model);
			console.log(...arguments);
			let id = model.id;
			
			this.updateDataReturnValue = 'SUBMITTED';
			if (id != '' && id != null && id != undefined) {
				ApprovalConfigurationDetail.updateDataDetail(this, model, id).then(result => {
					//this.$router.push({ name: 'approvalconfigurationindex' });
					this.isBusy = false;
					this.updateDataReturnValue = true;
				}).catch(error => { this.isBusy = false;
					this.updateDataReturnValue = false;
				});
			}
		},
		onHidden() {
			this.getApprovalConfigurations();
		},
		addDataApprovalConfigurationDetail() {
			this.approvalConfigurationDetailId = "";
			this.isShowPopupApprovalConfigurationDetail = true;
		},
		addRowDataApprovalConfigurationDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.approvalConfigurationId =  this.modelId;
					ApprovalConfigurationDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getApprovalConfigurationDetails(true);
						this.isShowPopupApprovalConfigurationDetail = false;
					})
				} else {
					model.approvalConfigurationId =  this.modelId;
					ApprovalConfigurationDetail.createDataDetail(this, model)
					.then(result => {
						this.getApprovalConfigurationDetails(true);
						this.isShowPopupApprovalConfigurationDetail = false;
					})
				}
			}
		},
		editDataApprovalConfigurationDetail(model) {
			console.log(model.item);
			this.approvalConfigurationDetailId = model.item.id;
			this.isShowPopupApprovalConfigurationDetail = true;
		},
		
		deleteDataApprovalConfigurationDetail(model) {
			let id = model.item.id;
			
			ApprovalConfigurationDetail.deleteData(this, id).then(result => { this.getApprovalConfigurationDetails(); });
		}
	},
	/*APP_DETAIL_BEFORE_MOUNT*/
	beforeMount() {
		this.filterApprovalConfiguration = new ApprovalConfigurationFilter();
		this.filterApprovalConfigurationDetail = new ApprovalConfigurationDetailFilter();
	},
	/*END_APP_DETAIL_BEFORE_MOUNT*/
	/*APP_DETAIL_MOUNTED*/
	mounted(){
		let id = this.$route.params.id;
		this.modelId = id;
		this.getApprovalConfiguration(id);
		//this.getApprovalConfigurationDetails();
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	/*END_APP_DETAIL_MOUNTED*/
	watch : {
		/*APP_DETAIL_WATCH_APPROVALCONFIGURATIONDETAIL*/
		sortByApprovalConfigurationDetail : {
			handler: function() {
				this.getApprovalConfigurationDetails();
			}
		},
		sortDescApprovalConfigurationDetail: {
			handler: function() {
				this.getApprovalConfigurationDetails();
			}
		},
		currentApprovalConfigurationDetailPage: {
			handler: function() {
				this.getApprovalConfigurationDetails();
			}
		},
		approvalConfigurationDetailPageSize : {
			handler: function() {
				this.getApprovalConfigurationDetails();
			}
		},
		filterApprovalConfigurationDetail: {
			handler: function() {
				this.getApprovalConfigurationDetails();
			},
			deep: true,
		},
		/*END_APP_DETAIL_WATCH_APPROVALCONFIGURATIONDETAIL*/
	},
	/*APP_DETAIL_COMPUTED*/
	computed: {
	}
	/*END_APP_DETAIL_COMPUTED*/
}
</script>
